/**
 * Class to define header of an Http Request
 */
export class HttpHeader {
  name = '';
  value = '';
}
